import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToPageProps } from 'interview/i18n'
import GenericLayout from 'interview/components/layout/generic-layout'
import Html from 'components/html/html'
import Closed from 'interview/components/closed'
import PublicClosed from 'interview/components/public-closed'
import { PageContent } from 'components/styled/page/page-content'

const propTypes = {
  i18n: PropTypes.shape({
    finished: PropTypes.shape({
      descriptionsupport: PropTypes.func,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
}
export function ClosedPage({ i18n, location: { pathname } }) {
  if (pathname === '/public/closed') {
    return (
      <GenericLayout>
        <PublicClosed />
      </GenericLayout>
    )
  }
  if (
    pathname === '/interview/embedded/closed' ||
    pathname === '/interview/profile/closed'
  ) {
    return (
      <PageContent>
        <Closed />
      </PageContent>
    )
  }
  if (pathname === '/sequenced-interview/closed') {
    return (
      <GenericLayout>
        <Closed />
      </GenericLayout>
    )
  }
  return (
    <GenericLayout>
      <Closed>
        <Html
          html={i18n.finished.descriptionsupport(
            `<a href='mailto:${i18n.supportLink}'>${i18n.supportLink}</a>`
          )}
        />
      </Closed>
    </GenericLayout>
  )
}

ClosedPage.propTypes = propTypes

export default connect(mapLanguageToPageProps())(ClosedPage)
